module.exports = __webpack_public_path__ + "img/logo.874d9a2c.png";